import React, { useEffect, useState } from 'react';
import { Col, Form } from 'antd';
import 'react-app-polyfill/stable';
import PartWrapper from 'mixins/ui/part-wrapper';
import Button from 'mixins/ui/button/button';
import ArrowIcon from './arrow.svg';
import { filterDictionary } from '/react4xp/parts/admin-dictionary/actions';

type Props = {
    selectedItem: any;
    setSelectedItem: (selectedItem: any) => void;
    params: any;
    setParams: (data) => void;
};

const RevenueList: React.FC<Props> = ({ selectedItem, setSelectedItem, setParams, params }) => {
    const [fieldValues, setFieldValues] = useState<any>();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [childrenShow, setChildrenShow] = useState(null);

    const clearForm = () => {
        form.resetFields();
    };

    useEffect(() => {
        filterDictionary(
            {
                dictionaryCode: 'tax_org_shadow',
                page: 0,
                size: 255,
            },
            {}
        )
            .then(({ data }) => {
                const mergedDictionary = [];

                data.dictionary.forEach((item) => {
                    if (item.a_in_level_num === 2) {
                        const level2Object = { ...item, children: [] };
                        mergedDictionary.push(level2Object);
                    } else if (item.a_in_level_num === 3) {
                        const parentIndex = mergedDictionary.findIndex(
                            (parent) => parent.a_in_id === item.a_in_parent_id
                        );
                        if (parentIndex !== -1) {
                            mergedDictionary[parentIndex].children.push(item);
                        }
                    }
                });

                setData(mergedDictionary);
            })
            .finally(() => setLoading(false));
    }, []);

    const selectItem = (item) => {
        setSelectedItem((prevSelectedItem) => {
            const newSelectedItem =
                item.a_in_code === prevSelectedItem
                    ? null
                    : item.a_in_code;

            setParams({ ...params, a_in_code: newSelectedItem });
            return newSelectedItem;
        });
    }

    return (
        <>
            <div className="revenue-list">
                <ul>
                    {data.map((item) => (
                        <>
                            <Col className="list-parent">
                                <li
                                    onClick={() => selectItem(item)}
                                    className={item.a_in_code === selectedItem ? 'active' : ''}>
                                    {item.a_in_name}
                                </li>
                                {item?.children.length > 0 && (
                                    <Button
                                        className="p-0"
                                        shape="default"
                                        style={{
                                            border: 'none',
                                            height: 20,
                                            boxShadow: 'none',
                                        }}
                                        icon={
                                            <ArrowIcon
                                                style={{
                                                    rotate:
                                                        childrenShow == item.a_in_code
                                                            ? '0deg'
                                                            : '270deg',
                                                }}
                                            />
                                        }
                                        onClick={() =>
                                            setChildrenShow(
                                                item.a_in_code === childrenShow
                                                    ? null
                                                    : item.a_in_code
                                            )
                                        }
                                    />
                                )}
                            </Col>

                            {childrenShow == item.a_in_code && (
                                <ul
                                    style={{
                                        borderBottom: '1px solid #e6e6ef',
                                    }}
                                >
                                    {item.children?.map((c) => (
                                        <li
                                            onClick={() => {
                                                setSelectedItem((prevSelectedItem) => {
                                                    const newSelectedItem =
                                                        c.a_in_code === prevSelectedItem
                                                            ? null
                                                            : c.a_in_code;
                                                    setParams({
                                                        ...params,
                                                        a_in_code: newSelectedItem,
                                                    });
                                                    return newSelectedItem;
                                                });
                                            }}
                                            className={c.a_in_code === selectedItem ? 'active' : ''}
                                            style={{
                                                paddingLeft: 30,
                                            }}
                                            key={c.a_in_id}
                                        >
                                            {c.a_in_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default (props) => (
    <PartWrapper {...props}>
        <RevenueList {...props} />
    </PartWrapper>
);
